import {BlockBlobClient} from '@azure/storage-blob';

import ServiceResponse from '../models/ServiceResponse';




function base64toBlob(base64Data, contentType) {
    contentType = contentType || '';
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);

        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
}

export default class AzureStorageService 
{
    constructor()
    {
        this.account = 'gcblobstoredurable1'; 
        //this.blobSasUrl = 'https://gcblobstoredurable1.blob.core.windows.net/?sv=2019-10-10&ss=b&srt=sco&sp=rwdlacx&se=2020-07-04T11:02:14Z&st=2020-07-04T03:02:14Z&spr=https,http&sig=LyLJUi%2BnWHsG1FthUYursp7ahFWhsY8DIxsiWlIkWG8%3D';
        //this.blobServiceClient = new BlobServiceClient(this.blobSasUrl);
    }

    // assumes you have already passed authorization and obtained a tokenized sasUri with a token from core service
    async uploadBlobFile(blobString, sasUri)
    {
        try
        {
            if (!blobString) return ServiceResponse.toServiceResponse(["No data passed to upload!", true]);
            // get the mime type
            var tokens = blobString.split(",");
            var mimeType = tokens[0];
            var b64Payload = tokens[1];
            var blobType = this.blobTypeFromMimeType(mimeType);
            // fetch the sas Uri
            //let sasUri = await this.apiClient.fetchAzureStorageSasUri(imageId, imageType);
            //var blobServiceClient = new BlobServiceClient(sasUri);
            var blockBlobClient = new BlockBlobClient(sasUri);
            //var contentType = 'image/' + imageType;
            //console.log(userImageString);
            // we have to strip off the data tag at the beginning of the file
            //let cleanedImageString = userImageString.replace('data:image/' + imageType + ';base64,', '');
            var blob = base64toBlob(b64Payload);
            //console.group("blob content length:");
            //console.log(blob.size);
            const uploadBlobResponse = await blockBlobClient.upload(blob, blob.size);
            console.log('Upload block blob ${blobName} successfully', uploadBlobResponse.requestId); 
            return ServiceResponse.toServiceResponse("Successfuly uploaded file.", false);
        }
        catch(e)
        {
            var msgs = new Array(e.message);
            msgs.push("Problem uploading User File.");
            return ServiceResponse.toServiceResponse(msgs, true);
        }
    }

      
    
    blobTypeFromMimeType(mimeType)
    {
        var tokenize1 = mimeType.split("/");
        var tokenize2 = tokenize1[1].split(";");
        var result = tokenize2[0];
        return result;
    }


    imageTypeFromMimeType(mimeType)
    {
        var tokenize1 = mimeType.split("/");
        var tokenize2 = tokenize1[1].split(";");
        var result = tokenize2[0];
        return result;
    }

    // png, jpeg, etc. 
    async uploadUserImage(userImageString, sasUri)
    {
        try
        {
            if (!userImageString) return ServiceResponse.toServiceResponse(["No data passed to upload!", true]);
            // get the mime type
            var tokens = userImageString.split(",");
            var mimeType = tokens[0];
            var b64Payload = tokens[1];
            var imageType = this.imageTypeFromMimeType(mimeType);
            // fetch the sas Uri
            //let sasUri = await this.apiClient.fetchAzureStorageSasUri(imageId, imageType);
            //var blobServiceClient = new BlobServiceClient(sasUri);
            var blockBlobClient = new BlockBlobClient(sasUri);
            //var contentType = 'image/' + imageType;
            //console.log(userImageString);
            // we have to strip off the data tag at the beginning of the file
            //let cleanedImageString = userImageString.replace('data:image/' + imageType + ';base64,', '');
            var blob = base64toBlob(b64Payload);
            //console.group("blob content length:");
            //console.log(blob.size);
            const uploadBlobResponse = await blockBlobClient.upload(blob, blob.size);
            console.log('Upload block blob ${blobName} successfully', uploadBlobResponse.requestId); 
            return ServiceResponse.toServiceResponse("Successfuly uploaded file.", false);
        }
        catch(e)
        {
            var msgs = new Array(e.message);
            msgs.push("Problem uploading User File.");
            return ServiceResponse.toServiceResponse(msgs, true);
        }
    }

}